import React from "react";
import { useTranslation } from "react-i18next";
import { CodeIcon, CrownIcon, QuizIcon } from "./Icons";

const PIPS = { easy: 1, medium: 2, hard: 3 };

export function DifficultyBadge({ difficulty }) {
  const { t } = useTranslation();
  const filled = PIPS[difficulty] || 1;
  return (
    <span className={`difficulty difficulty--${difficulty}`} title={t(`level.${difficulty}`)}>
      <span className="difficulty__pips" aria-hidden="true">
        {[1, 2, 3].map((pip) => (
          <span key={pip} className={pip <= filled ? "is-filled" : ""} />
        ))}
      </span>
      <span className="difficulty__label">{t(`level.${difficulty}`)}</span>
    </span>
  );
}

export function TypeBadge({ type }) {
  const { t } = useTranslation();
  return (
    <span className="type-badge">
      {type === "quiz" ? <QuizIcon size={13} /> : <CodeIcon size={13} />}
      {t(`level.${type}`)}
    </span>
  );
}

export function BossBadge() {
  const { t } = useTranslation();
  return (
    <span className="boss-badge">
      <CrownIcon size={12} />
      {t("level.boss")}
    </span>
  );
}

export function ProgressBar({ value, total, label }) {
  const percent = total ? Math.round((value / total) * 100) : 0;
  return (
    <div
      className="progress"
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={total}
      aria-valuenow={value}
      aria-label={label}
    >
      <div className="progress__fill" style={{ width: `${percent}%` }} />
    </div>
  );
}
